import React from 'react'

export const Banner = ({ children, imageSource, isLoading, setIsLoading }) => {
    return (
        <div className='banner'>
            {
                isLoading &&
                <div className='shimmer-wrapper'>
                    <div className='shimmer'>
                        <img
                            style={{ visibility: 'hidden' }}
                            src={imageSource}
                            alt='banner-img'
                            onLoad={() => setIsLoading(false)}
                        />
                    </div>

                </div>
            }
            {
                !isLoading &&
                <img
                    src={imageSource}
                    alt='banner-img'
                />
            }
            <div className='items-on-banner'>{children}</div>
        </div>
    )

}
